import React, { lazy } from 'react'

import lazyRetry from '../../../utils/lazyRetry'
import './footer.scss'

interface Props {
  hideAboveFooter: boolean | undefined
}

const AboveFooter = lazy(() =>
  lazyRetry(() => import('./AboveFooter'), 'AboveFooter')
)

const BelowFooter = lazy(() =>
  lazyRetry(() => import('./BelowFooter'), 'BelowFooter')
)

const Footer = ({ hideAboveFooter }: Props) => {
  return (
    <>
      <AboveFooter hideAboveFooter={hideAboveFooter} />

      <BelowFooter />
    </>
  )
}

export default Footer
